var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
var RequestFund = function () {
    var _a = __read(React.useState({}), 2), paylinkScenario = _a[0], setPaylinkScenario = _a[1];
    var _b = __read(React.useState(), 2), selectedData = _b[0], setSelectedData = _b[1];
    var _c = __read(React.useState(false), 2), selected = _c[0], setSelected = _c[1];
    var _d = __read(React.useState(), 2), dropdown = _d[0], setDropdown = _d[1];
    var _e = __read(React.useState({
        reasonname: "",
        communicationtemplate: "",
        paymentlinkvaildity: 0,
        Amount: "",
        StakeHolder: "",
    }), 2), formData = _e[0], setFormData = _e[1];
    var _f = __read(React.useState({
        reasonname: "",
        communicationtemplate: "",
        paymentlinkvaildity: "",
        Amount: "",
    }), 2), error = _f[0], setError = _f[1];
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var handleChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.currentTarget.name] = event.currentTarget.value, _a)));
    };
    useEffect(function () {
        getPaymentScenarioDetails();
    }, []);
    var getPaymentScenarioDetails = function () {
        di.clients
            .getPaylinkScenarioDetails()
            .then(function (apiresponse) {
            if ((apiresponse === null || apiresponse === void 0 ? void 0 : apiresponse.length) > 0) {
                setPaylinkScenario(apiresponse[0]);
                var dropdownResp = apiresponse.map(function (record) {
                    return {
                        value: record.reasonname,
                        display: record.reasonname,
                    };
                });
                setDropdown(dropdownResp);
                // setDropdown([
                //   {
                //     value: apiresponse[0]?.reasonname,
                //     display: apiresponse[0]?.reasonname,
                //   },
                // ]);
            }
            else {
                setPaylinkScenario({});
                setDropdown([]);
            }
        })
            .catch(function (error) {
            setPaylinkScenario({});
            setDropdown([]);
            console.log("Payment Scenario Failure", error.data);
        });
    };
    useEffect(function () {
        setFormData(function (prevState) {
            return {
                reasonname: paylinkScenario.reasonname,
                communicationtemplate: paylinkScenario.communicationtemplate,
                paymentlinkvaildity: paylinkScenario.paymentlinkvaildity,
                Amount: prevState.Amount,
                StakeHolder: paylinkScenario.stakeholder,
            };
        });
    }, [paylinkScenario]);
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var generatePaymentDetails = function () {
        var payload = {
            payinfo: [
                { accountCode: selectedAcount.accountCode, amount: formData.Amount },
            ],
            reason: formData.reasonname,
            validity: formData.paymentlinkvaildity,
            //StakeHolder: formData.StakeHolder,
        };
        di.clients
            .generatePaymentLink(payload)
            .then(function (apiresponse) {
            alert(apiresponse.data);
            console.log("generate Paayment Success", apiresponse.data);
        })
            .catch(function (errors) {
            alert(errors.data);
            console.log("Generate Payment Failure", errors.data);
        });
    };
    var disableKill = function () {
        return (!formData.Amount ||
            !formData.communicationtemplate ||
            !formData.paymentlinkvaildity ||
            !formData.reasonname ||
            error.Amount.length > 0 ||
            error.communicationtemplate.length > 0 ||
            error.paymentlinkvaildity.length > 0 ||
            error.reasonname.length > 0);
    };
    console.log("Paylink value form data", selected, formData);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Row, { className: "pdb-40 m-0 grid-121-80" },
                React.createElement(Col, { className: "px-0" },
                    React.createElement("div", { className: "px-0 mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Reason")),
                    React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                        React.createElement(SelectDropdown, { placeholder: "Select", placeholderClassName: "", id: "reasonname", name: "reasonname", required: true, downarrow: "edel-icon-arrow-down", dropdownOptions: dropdown || [], onChangeEvent: function (e) {
                                setSelectedData(e.target.value);
                                setSelected(true);
                                handleChange(e);
                            } }))),
                React.createElement(Col, { className: "px-0" },
                    React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Communication Template")),
                    React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                        React.createElement(InputField, { placeholder: "NA", id: "communicationtemplate", name: "communicationtemplate", autoComplete: "off", placeholderClassName: "", defaultValue: selected == true ? paylinkScenario.communicationtemplate : "", onChangeEvent: function (e) { return handleChange(e); }, onBlur: function (error, event) {
                                if (error.required)
                                    validationError(event.target.name, "This field is Required");
                                else
                                    validationError(event.target.name, "");
                            }, errorText: error === null || error === void 0 ? void 0 : error.communicationtemplate }))),
                React.createElement(Col, { className: "px-0" },
                    React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Validity of link (in Hours)")),
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(InputField, { placeholder: "NA", id: "paymentlinkvaildity", name: "paymentlinkvaildity", autoComplete: "off", placeholderClassName: "", defaultValue: selected == true
                                ? paylinkScenario.paymentlinkvaildity.toString()
                                : "", onBlur: function (error, event) {
                                if (error.required)
                                    validationError(event.target.name, "This field is Required");
                                else
                                    validationError(event.target.name, "");
                            }, errorText: error === null || error === void 0 ? void 0 : error.paymentlinkvaildity, onChangeEvent: function (e) { return handleChange(e); } })))),
            React.createElement(Row, { className: " m-0 pdb-40 grid-121-80" },
                React.createElement(Col, { className: "px-0" },
                    React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Account Code")),
                    React.createElement(Col, { className: "px-0 leadpage-selectdropdown DMSans_16_500" },
                        React.createElement(InputField, { placeholder: "Account Code", id: "accountcode", name: "accountcode", autoComplete: "off", placeholderClassName: "", defaultValue: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, onChangeEvent: function (e) { return handleChange(e); }, disabled: true }))),
                React.createElement(Col, { className: "px-0" },
                    React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Amount (Only For Equity Accounts)")),
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(InputField, { placeholder: "NA", id: "Amount", name: "Amount", autoComplete: "off", placeholderClassName: "", 
                            // defaultValue={}
                            onChangeEvent: function (e) { return handleChange(e); }, onBlur: function (error, event) {
                                if (error.required)
                                    validationError(event.target.name, "This field is Required");
                                else
                                    validationError(event.target.name, "");
                            }, errorText: error === null || error === void 0 ? void 0 : error.Amount })))),
            React.createElement(Row, { className: "triggercommunication-btn" },
                React.createElement(EdButton, { className: "dmSan", btnTyp: "midnight-blue", value: "Trigger Communication", disabled: disableKill(), onClick: function (e) {
                        e.preventDefault();
                        generatePaymentDetails();
                    } })))));
};
export default RequestFund;
